import React from "react";
import { ContainnerProvider } from "@qt-rc/bms";
import { AudioProvider } from "@qt-rc/global-audio";
import "@qt-base/css-common";
import "@qt-rc/bms/dist/style.css";
import "@qt-rc/bms-marketing/dist/style.css";
import "@qt-base/linkedme";
import "@qt-base/jssdk";
import "@qt-rc/common-expose";
import "@qt-rc/modal";
import "@qt-rc/toast";
import componentsCtrl from "@qt-builder/components-ctrl";
import { Image } from "@qt-rc/bms";
import { TingList } from "@qt-rc/ting-list";
import { AudioContext } from "@qt-rc/global-audio";
import { Channels } from "@qt-rc/channel-list";
import "@qt-rc/channel-list/dist/style.css";
import { useState, useEffect } from "react";
import axios from "axios";
import Channels__8 from "@qt-topic/channel-list";
import "@qt-topic/channel-list/index.css";
import Channels__10 from "@qt-topic/channel-list";
import Channels__12 from "@qt-topic/channel-list";
window.__BUILDER_PROJECT_ID = '62c52dc88921eb7b4618f35a';
window.__BUILDER_PAGE_ID = '62c52dc88921eb5df518f35e';
window.__BUILDER_COMPONENTS_CTRL = '{}';
componentsCtrl.init({});
console.log('linkedme', window.linkedme);
if (window.linkedme) window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
  type: 'live'
}, null);

const WrapContainer = ({
  id: id,
  nodeId: nodeId,
  nodeType: nodeType,
  children: children,
  pageConfig: pageConfig,
  appShareConfig: appShareConfig,
  timeConfig: timeConfig
}) => {
  console.log('current env is: ', process.env.SITE_ENV);
  return <ContainnerProvider id={id} nodeId={nodeId} nodeType={nodeType} children={children} pageConfig={pageConfig} appShareConfig={appShareConfig} timeConfig={timeConfig} env={process.env.SITE_ENV}>
      <AudioProvider>{children}</AudioProvider>
    </ContainnerProvider>;
};

const imageConfig = {
  src: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/416ea684facae45d19ac84205483aa19.jpg",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: false,
  openExpose: false
};
const imageStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__2 = {
  src: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/8021065c3be2dc23b4766d7623d41f88.jpg",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__2 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const tingConfig = {
  showPlayAll: false,
  playAllText: "全部播放",
  showProgramCount: true,
  showPlayCount: true,
  showPlayDuration: true,
  showChannelName: true,
  showPodcasterName: true,
  tingId: 105769
};
const tingStyle = {
  list: {
    backgroundColor: "#a70b0b"
  },
  card: {
    backgroundColor: "#FFFFFF"
  },
  playAllButton: {
    color: "#FFFFFF",
    backgroundColor: ""
  }
};
const imageConfig__4 = {
  src: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/5fa457b0790cb991a949d129df8e9073.jpg",
  link: "https://bp.qtfm.cn/topic/62d76192524b2b65cef486f3/index.html",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: false,
  openExpose: false
};
const imageStyle__4 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const config = {
  channelIDs: "450009,449677,450018,447086",
  channelsData: [{
    link: {
      content: "450009"
    },
    imgUrl: "http://pic.qtfm.cn/device/1317ff845f8e4f1e80146ab0671d738e/1663126941275_vDVjMXKJq.png!200",
    gridContent: "",
    title: "微纪录片《这十年》",
    recWords: "微观视角宏观展现中国这十年发展巨变和成就",
    icon: "",
    podcasters: [{
      "qingting_id": "6a1baf7b2a5d534a55df5701a6ab5f41",
      "nick_name": "蜻蜓党支部",
      "avatar": "http://pic.qtfm.cn/2018/08/06/partner_c3e5dab5349e955f30c247c61aff8806.png",
      "sns_open": false,
      "award_open": "0"
    }],
    originPrice: 0,
    sale: ""
  }, {
    link: {
      content: "449677"
    },
    imgUrl: "http://pic.qtfm.cn/channel/2022/09/08/d31406e18dc72731962bcc016efadb6f.png!200",
    gridContent: "",
    title: "中国这十年\xB7系列主题新闻发布",
    recWords: "回顾十年辉煌成就  展望未来伟大征程",
    icon: "",
    podcasters: [{
      "qingting_id": "6a1baf7b2a5d534a55df5701a6ab5f41",
      "nick_name": "蜻蜓党支部",
      "avatar": "http://pic.qtfm.cn/2018/08/06/partner_c3e5dab5349e955f30c247c61aff8806.png",
      "sns_open": false,
      "award_open": "0"
    }],
    originPrice: 0,
    sale: ""
  }, {
    link: {
      content: "450018"
    },
    imgUrl: "http://pic.qtfm.cn/device/1317ff845f8e4f1e80146ab0671d738e/1663139304628_oeHQvIxpl.png!200",
    gridContent: "",
    title: "非凡十年，从1到N",
    recWords: "细数上海这十年从1到N发展起来的新事物",
    icon: "",
    podcasters: [{
      "qingting_id": "6a1baf7b2a5d534a55df5701a6ab5f41",
      "nick_name": "蜻蜓党支部",
      "avatar": "http://pic.qtfm.cn/2018/08/06/partner_c3e5dab5349e955f30c247c61aff8806.png",
      "sns_open": false,
      "award_open": "0"
    }],
    originPrice: 0,
    sale: ""
  }, {
    link: {
      content: "447086"
    },
    imgUrl: "http://pic.qtfm.cn/device/ceb269e9d34d4e6a8fe9612c9e6ff01e/1659178902400_TsIQLdlJX.jpg!200",
    gridContent: "",
    title: "“典”亮中国梦",
    recWords: "学习典故的时代价值  分享党的精神密码",
    icon: "",
    podcasters: [{
      "qingting_id": "a2204e66961ef37d4b64fd5af14d7b86",
      "nick_name": "海峡之声",
      "avatar": "http://pic.qtfm.cn/2017/06/02/partner_c64dccb730fd4f2bbbdae40a5cb043a3.jpg",
      "sns_open": false,
      "award_open": "0"
    }],
    originPrice: 0,
    sale: ""
  }],
  type: "gridTwo",
  template: "none",
  containerStyle: {
    "paddingTop": 10,
    "paddingRight": 10,
    "paddingBottom": 10,
    "paddingLeft": 10,
    "backgroundColor": "#a70b0b"
  },
  cardConfig: {
    showPlayProgram: false,
    titleColor: "#333",
    titleBg: "#4100c4",
    descColor: "#777777",
    playProgramColor: "#f7f8f7",
    originPriceColor: "#999999",
    nowPriceColor: "#e73e3c",
    channelBg: "#faf9f7",
    channelHeight: "",
    sale: "",
    icon: "",
    iconWidth: 34
  },
  buttonConfig: {
    showBtn: false,
    btnBg: "#e73d3b",
    btnText: "免费试听",
    btnTextOutApp: "打开APP收听",
    btnTextColor: "#ffffff"
  },
  configFor91: {
    bottomIcon: "",
    bottomIconColor: "#fff",
    priceContainerColor1: "#ffdd8c",
    priceContainerColor2: "#f9eac5"
  },
  logConfig: {
    popTrack: true,
    clickTrack: true
  }
};
const imageConfig__6 = {
  src: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/4e53b12ca703c9a8ee0949697bfad58c.jpg",
  link: "https://bp.qtfm.cn/topic/6346249d8899ef7fa0aa46ab/index.html",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__6 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const imageConfig__7 = {
  src: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/7c6ddf158e8215a9060ec669b9cd736d.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__7 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const icon = "";
const channel_ids = "445479,445463,229190,398228,412133,396746";
const channelsData = [{
  link: {
    content: "445479"
  },
  imgUrl: "http://pic.qtfm.cn/device/adb39a1fff71455b997afa6d1f502374/1657187988604_1jSWMOZek.jpg!200",
  gridContent: "",
  title: "党代会知多少",
  recWords: "这些关于党代会的知识  你了解多少",
  icon: "",
  podcasters: [{
    "qingting_id": "6a1baf7b2a5d534a55df5701a6ab5f41",
    "nick_name": "蜻蜓党支部",
    "avatar": "http://pic.qtfm.cn/2018/08/06/partner_c3e5dab5349e955f30c247c61aff8806.png",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "445463"
  },
  imgUrl: "http://pic.qtfm.cn/device/adb39a1fff71455b997afa6d1f502374/1657178356701_9ioJkPSCz.jpg!200",
  gridContent: "",
  title: "伟大的奋斗 从一大到二十大",
  recWords: "回望党的伟大历史 传承党的奋斗精神",
  icon: "",
  podcasters: [{
    "qingting_id": "6a1baf7b2a5d534a55df5701a6ab5f41",
    "nick_name": "蜻蜓党支部",
    "avatar": "http://pic.qtfm.cn/2018/08/06/partner_c3e5dab5349e955f30c247c61aff8806.png",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "229190"
  },
  imgUrl: "http://pic.qtfm.cn/2017/10/16/partner_60fd821fcc6672f29325b2159c0ea02f.jpg!200",
  gridContent: "",
  title: "聚焦十九大\xB7高端对话",
  recWords: "回顾十九大伟大成就 迎接二十大胜利召开",
  icon: "",
  podcasters: [{
    "qingting_id": "6c1d00fcdae1d8364c0035ec05d7d845",
    "nick_name": "FM93浙江交通之声",
    "avatar": "http://pic.qtfm.cn/2017/03/08/partner_4ec6f0a256d696ae6579fdcf05b3bf7b.jpg",
    "sns_open": false,
    "award_open": "99"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "398228"
  },
  imgUrl: "http://pic.qtfm.cn/channel/2021/06/10/2f7c604bd640b3a03d0ba2b1f9c012ca.jpg!200",
  gridContent: "",
  title: "写给青少年的党史",
  recWords: "献给孩子的有温度、有厚度的党史学习读本",
  icon: "",
  podcasters: [{
    "qingting_id": "36cbb2ec652446f8a83c9d54309917d5",
    "nick_name": "青岛出版社官方账号",
    "avatar": "http://pic.qtfm.cn/device/66441c7733854167b9ffa4d94274e6e4/1621934608919_5J5h677Gr.jpg",
    "sns_open": false,
    "award_open": "99"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "412133"
  },
  imgUrl: "http://pic.qtfm.cn/channel/2021/07/06/57b637f10adf3409c1ff7b1b0e45ce8e.jpg!200",
  gridContent: "",
  title: "中国共产党章程",
  recWords: "不忘初心重温党章  牢记使命坚定信仰",
  icon: "",
  podcasters: [{
    "qingting_id": "6a1baf7b2a5d534a55df5701a6ab5f41",
    "nick_name": "蜻蜓党支部",
    "avatar": "http://pic.qtfm.cn/2018/08/06/partner_c3e5dab5349e955f30c247c61aff8806.png",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "396746"
  },
  imgUrl: "http://pic.qtfm.cn/channel/2021/03/09/87da824d628e1dee32160dea98c2dddb.jpg!200",
  gridContent: "",
  title: "十九大党章公开课",
  recWords: "十九大新党章做了哪些修改  新增了哪些内容",
  icon: "",
  podcasters: [{
    "qingting_id": "6a1baf7b2a5d534a55df5701a6ab5f41",
    "nick_name": "蜻蜓党支部",
    "avatar": "http://pic.qtfm.cn/2018/08/06/partner_c3e5dab5349e955f30c247c61aff8806.png",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}];
const showType = {
  type: "gridThree",
  template: "none"
};
const hasPromotion = true;
const customStyle = {
  popTrack: false,
  clickTrack: false,
  showBtn: false,
  iconWidth: 34,
  btnBg: "#e73d3b",
  btnText: "免费试听",
  btnTextOutApp: "打开APP收听",
  btnTextColor: "#ffffff",
  showPlayProgram: false,
  bg: "#a70b0b",
  titleColor: "#333",
  titleBg: "#f8f8f6",
  descColor: "#777777",
  playProgramColor: "#f7f8f7",
  originPriceColor: "#999999",
  nowPriceColor: "#e73e3c",
  channelBg: "#faf9f7",
  channelHeight: "",
  bottomIcon: "",
  sale: "",
  bottomIconColor: "#fff",
  priceContainerColor1: "#ffdd8c",
  priceContainerColor2: "#f9eac5",
  marginTop: 10,
  marginLeft: 10,
  marginBottom: 10,
  marginRight: 10
};
let cacheChannels = [];

const ChannelList = ({
  nodeType: nodeType,
  nodeId: nodeId,
  channelsData: channelsData,
  customStyle: customStyle,
  showType: showType,
  icon: icon
}) => {
  const [channels, setChannels] = useState([]);

  const getChannels = () => {
    let api = axios.create({
      baseURL: `https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qtfm.cn`
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels`, {
      params: {
        ids: channel_ids,
        hasPromotion
      }
    }).then(data => {
      const channels = data.channels;
      channels.forEach(item => {
        item.nowPrice = item.promotionPrice;
      });
      const newChannels = channels;

      if (channelsData[0].title) {
        newChannels.forEach((item, i) => {
          Object.assign(item, channelsData[i]);
        });
      }

      formatData(newChannels);
      setChannels(newChannels);
      cacheChannels = newChannels;
    });
  };

  const checkIfDynamic = () => {
    if (showType.type !== 'unionVip' && (showType.template === 'price' || showType.template === '91sale' || customStyle.showPlayProgram)) {
      return true;
    }

    return false;
  };

  const formatData = data => {
    data.forEach(item => {
      if (!item.icon && icon) {
        item.icon = icon;
      }

      if (!item.sale && customStyle.sale) {
        item.sale = customStyle.sale;
      }
    });
  };

  useEffect(() => {
    if (!checkIfDynamic()) {
      formatData(channelsData);
      setChannels(channelsData);
      return;
    }

    if (cacheChannels.length > 0) {
      formatData(cacheChannels);
      setChannels(cacheChannels);
      return;
    }

    getChannels();
  }, []);
  return <Channels__8 channels={channels} customStyle={customStyle} type={showType.type} template={showType.template} nodeId={nodeId} nodeType={nodeType}></Channels__8>;
};

const imageConfig__9 = {
  src: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/350f48f71ab9959cc2646d16262c46b2.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__9 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const channel_ids__10 = "410483,410574,405086,416931,410653,406286";
const channelsData__10 = [{
  link: {
    content: "410483"
  },
  imgUrl: "http://pic.qtfm.cn/device/d913c940a4c5428bbaf00bee3d7a8203/1624345845564_ZvuanTMEd.jpg!200",
  gridContent: "",
  title: "对党说句心里话",
  recWords: "回忆百年党史 诉说合作初心",
  icon: "",
  podcasters: [{
    "qingting_id": "965482986fd90f8611ec4575d9ea7c4d",
    "nick_name": "西青区委统战部",
    "avatar": "https://pic.qtfm.cn/qtfm/2020/12/04/qingting-kf-avatar.png",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "410574"
  },
  imgUrl: "http://pic.qtfm.cn/channel/2021/06/23/8172c5e2ee994c7413be160c753d01bc.jpg!200",
  gridContent: "",
  title: "跟党走 奔幸福",
  recWords: "永远跟党走  幸福奔小康",
  icon: "",
  podcasters: [{
    "qingting_id": "765d19302867d659d0b75cbd1c7c891b",
    "nick_name": "陕西农村广播",
    "avatar": "http://pic.qtfm.cn/device/6001c3818a1c46e7bfaff8b88ca83899/1624504180619_7B08BCbBv.jpg",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "405086"
  },
  imgUrl: "http://pic.qtfm.cn/device/8651a9a1b11a4b55b43904697dfc685f/1620808082563_Puie277TZ.jpg!200",
  gridContent: "",
  title: "我想对党说",
  recWords: "坚定不移跟党走  百名党员话初心",
  icon: "",
  podcasters: [{
    "qingting_id": "809aaac8ea3c49e596fae8dffcd3d1d1",
    "nick_name": "赣州新闻综合广播",
    "avatar": "http://pic.qtfm.cn/device/8651a9a1b11a4b55b43904697dfc685f/1620719153396_sGb_6649I.jpg",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "416931"
  },
  imgUrl: "https://upload-up.qtfm.cn/user/841d260bade020f78414102c094ac493/1629080594_0001-332421950.png",
  gridContent: "",
  title: "我身边的党员故事",
  recWords: "感受平凡中的伟大  用生命诠释初心",
  icon: "",
  podcasters: [{
    "qingting_id": "841d260bade020f78414102c094ac493",
    "nick_name": "长春UFM880",
    "avatar": "http://pic.qtfm.cn/2018/03/08/partner_86631c684eeabda3e08f0279d40fe33e.jpg",
    "sns_open": false,
    "award_open": "99"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "410653"
  },
  imgUrl: "http://pic.qtfm.cn/device/d0ab1edc78a1412baec94a61ea6d695b/1624506209185_1iqynjI_3.jpg!200",
  gridContent: "",
  title: "红星何以照耀中国",
  recWords: "百年辉煌历程揭示红星何以照耀中国",
  icon: "",
  podcasters: [{
    "qingting_id": "bd3c33bc811c9fdba12199b05d4dbba9",
    "nick_name": "中国网",
    "avatar": "http://q.qlogo.cn/qqapp/100387802/71DBD79FABADA75EC20BD29F214305FD/100",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "406286"
  },
  imgUrl: "http://pic.qtfm.cn/device/3f273abffe954cdd9499fa916242688b/1621435742678_-o74_rLk2.jpeg!200",
  gridContent: "",
  title: "科技工作者心向党\xB7系列音频",
  recWords: "百年征程波澜壮阔  百年初心历久弥坚",
  icon: "",
  podcasters: [{
    "qingting_id": "0db0f838beac60863ad73a5012c9269b",
    "nick_name": "科心向党",
    "avatar": "http://pic.qtfm.cn/device/3f273abffe954cdd9499fa916242688b/1621435311609_LwjXbOHe8.jpeg",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}];
const showType__10 = {
  type: "gridThree",
  template: "none"
};
const customStyle__10 = {
  popTrack: false,
  clickTrack: false,
  showBtn: false,
  iconWidth: 34,
  btnBg: "#e73d3b",
  btnText: "免费试听",
  btnTextOutApp: "打开APP收听",
  btnTextColor: "#ffffff",
  showPlayProgram: false,
  bg: "#a70b0b",
  titleColor: "#333",
  titleBg: "#4100c4",
  descColor: "#777777",
  playProgramColor: "#f7f8f7",
  originPriceColor: "#999999",
  nowPriceColor: "#e73e3c",
  channelBg: "#f1f3f1",
  channelHeight: "",
  bottomIcon: "",
  sale: "",
  bottomIconColor: "#fff",
  priceContainerColor1: "#ffdd8c",
  priceContainerColor2: "#f9eac5",
  marginTop: 10,
  marginLeft: 10,
  marginBottom: 10,
  marginRight: 10
};
let cacheChannels__10 = [];

const ChannelList__10 = ({
  nodeType: nodeType,
  nodeId: nodeId,
  channelsData: channelsData__10,
  customStyle: customStyle__10,
  showType: showType__10,
  icon: icon
}) => {
  const [channels, setChannels] = useState([]);

  const getChannels = () => {
    let api = axios.create({
      baseURL: `https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qtfm.cn`
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels`, {
      params: {
        ids: channel_ids__10,
        hasPromotion
      }
    }).then(data => {
      const channels = data.channels;
      channels.forEach(item => {
        item.nowPrice = item.promotionPrice;
      });
      const newChannels = channels;

      if (channelsData__10[0].title) {
        newChannels.forEach((item, i) => {
          Object.assign(item, channelsData__10[i]);
        });
      }

      formatData(newChannels);
      setChannels(newChannels);
      cacheChannels__10 = newChannels;
    });
  };

  const checkIfDynamic = () => {
    if (showType__10.type !== 'unionVip' && (showType__10.template === 'price' || showType__10.template === '91sale' || customStyle__10.showPlayProgram)) {
      return true;
    }

    return false;
  };

  const formatData = data => {
    data.forEach(item => {
      if (!item.icon && icon) {
        item.icon = icon;
      }

      if (!item.sale && customStyle__10.sale) {
        item.sale = customStyle__10.sale;
      }
    });
  };

  useEffect(() => {
    if (!checkIfDynamic()) {
      formatData(channelsData__10);
      setChannels(channelsData__10);
      return;
    }

    if (cacheChannels__10.length > 0) {
      formatData(cacheChannels__10);
      setChannels(cacheChannels__10);
      return;
    }

    getChannels();
  }, []);
  return <Channels__10 channels={channels} customStyle={customStyle__10} type={showType__10.type} template={showType__10.template} nodeId={nodeId} nodeType={nodeType}></Channels__10>;
};

const imageConfig__11 = {
  src: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/58bef97d2ee09a77da0b1b8363cd3655.png",
  link: "",
  linkInApp: "",
  linkOutApp: "",
  openNewWebview: true,
  openExpose: false
};
const imageStyle__11 = {
  marginLeft: "auto",
  marginRight: "auto",
  position: "relative",
  width: "100%",
  left: 0,
  right: 0,
  zIndex: 1,
  boxSizing: "border-box"
};
const channel_ids__12 = "396552,387661,433575,440595,378097,437231";
const channelsData__12 = [{
  link: {
    content: "396552"
  },
  imgUrl: "http://pic.qtfm.cn/device/d0ab1edc78a1412baec94a61ea6d695b/1615168312278_GPB1JwFJU.png!200",
  gridContent: "",
  title: "未来什么样？",
  recWords: "代表委员寄语“十四五” 美好生活拼出来",
  icon: "",
  podcasters: [{
    "qingting_id": "bd3c33bc811c9fdba12199b05d4dbba9",
    "nick_name": "中国网",
    "avatar": "http://q.qlogo.cn/qqapp/100387802/71DBD79FABADA75EC20BD29F214305FD/100",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "387661"
  },
  imgUrl: "http://pic.qtfm.cn/device/5becc6d7ecba43988f64ee3b65438020/1609396454608_4h15EKVMW.jpeg!200",
  gridContent: "",
  title: "国家温度",
  recWords: "打赢脱贫攻坚战 一枝一叶总关情",
  icon: "",
  podcasters: [{
    "qingting_id": "94d10cf2477e0251291f4fc54d967448",
    "nick_name": "沈阳原创基地",
    "avatar": "http://pic.qtfm.cn/device/fb3aa468a89c44f496c82fad533eb992/1568779150491_AupkeujYu.jpeg",
    "sns_open": false,
    "award_open": "99"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "433575"
  },
  imgUrl: "http://pic.qtfm.cn/device/08327dd9ccfd4c7c8194862bfcd97188/1646032886608_-S2oy_YOj.png!200",
  gridContent: "",
  title: "中国共产党怎样解决贫困问题",
  recWords: "中国共产党脱贫历史上的伟大成就和创新经验",
  icon: "",
  podcasters: [{
    "qingting_id": "77350c7374ab686bbbd7715996cd97f2",
    "nick_name": "江西人民出版社书声朗",
    "avatar": "http://upload-up.qtfm.cn/device/852d2574ac2e47a785b59c79ce4dc83d/1553238431715_bwWzWyjIA.png",
    "sns_open": false,
    "award_open": "99"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "440595"
  },
  imgUrl: "http://pic.qtfm.cn/device/62fd4f01b5f242289fd05d6b96fe067f/1652237885519_4Oze3qB2k.jpg!200",
  gridContent: "",
  title: "广播剧《历程》",
  recWords: " 浙江共同富裕高质量发展真实记录",
  icon: "",
  podcasters: [{
    "qingting_id": "dd4ea4d93e00424146291031604b0840",
    "nick_name": "浙江科学技术出版社",
    "avatar": "http://pic.qtfm.cn/device/6b77b081c34b49778d7686aa39727b65/1560241977117_StQlB3AD4.jpeg",
    "sns_open": false,
    "award_open": "99"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "378097"
  },
  imgUrl: "http://pic.qtfm.cn/device/3f273abffe954cdd9499fa916242688b/1602830035434_57YTVyq96.png!200",
  gridContent: "",
  title: "决胜小康 奋斗有我",
  recWords: "千年梦想照进现实  ",
  icon: "",
  podcasters: [{
    "qingting_id": "0db0f838beac60863ad73a5012c9269b",
    "nick_name": "科心向党",
    "avatar": "http://pic.qtfm.cn/device/3f273abffe954cdd9499fa916242688b/1621435311609_LwjXbOHe8.jpeg",
    "sns_open": false,
    "award_open": "0"
  }],
  originPrice: 0,
  sale: ""
}, {
  link: {
    content: "437231"
  },
  imgUrl: "http://pic.qtfm.cn/device/81942de173804c4e88a7c503a9f8bbce/1648907895598_yDecZ0BIj.jpeg!200",
  gridContent: "",
  title: "同心抗疫 守护家园 ",
  recWords: "同心抗疫守护家园 致敬城市英雄 歌颂英雄城市",
  icon: "",
  podcasters: [{
    "qingting_id": "94d10cf2477e0251291f4fc54d967448",
    "nick_name": "沈阳原创基地",
    "avatar": "http://pic.qtfm.cn/device/fb3aa468a89c44f496c82fad533eb992/1568779150491_AupkeujYu.jpeg",
    "sns_open": false,
    "award_open": "99"
  }],
  originPrice: 0,
  sale: ""
}];
const showType__12 = {
  type: "gridThree",
  template: "none"
};
const customStyle__12 = {
  popTrack: false,
  clickTrack: false,
  showBtn: false,
  iconWidth: 34,
  btnBg: "#e73d3b",
  btnText: "免费试听",
  btnTextOutApp: "打开APP收听",
  btnTextColor: "#ffffff",
  showPlayProgram: false,
  bg: "#a70b0b",
  titleColor: "#333",
  titleBg: "#4100c4",
  descColor: "#777777",
  playProgramColor: "#f7f8f7",
  originPriceColor: "#999999",
  nowPriceColor: "#e73e3c",
  channelBg: "#ffffff",
  channelHeight: "",
  bottomIcon: "",
  sale: "",
  bottomIconColor: "#fff",
  priceContainerColor1: "#ffdd8c",
  priceContainerColor2: "#f9eac5",
  marginTop: 10,
  marginLeft: 10,
  marginBottom: 10,
  marginRight: 10
};
let cacheChannels__12 = [];

const ChannelList__12 = ({
  nodeType: nodeType,
  nodeId: nodeId,
  channelsData: channelsData__12,
  customStyle: customStyle__12,
  showType: showType__12,
  icon: icon
}) => {
  const [channels, setChannels] = useState([]);

  const getChannels = () => {
    let api = axios.create({
      baseURL: `https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qtfm.cn`
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels`, {
      params: {
        ids: channel_ids__12,
        hasPromotion
      }
    }).then(data => {
      const channels = data.channels;
      channels.forEach(item => {
        item.nowPrice = item.promotionPrice;
      });
      const newChannels = channels;

      if (channelsData__12[0].title) {
        newChannels.forEach((item, i) => {
          Object.assign(item, channelsData__12[i]);
        });
      }

      formatData(newChannels);
      setChannels(newChannels);
      cacheChannels__12 = newChannels;
    });
  };

  const checkIfDynamic = () => {
    if (showType__12.type !== 'unionVip' && (showType__12.template === 'price' || showType__12.template === '91sale' || customStyle__12.showPlayProgram)) {
      return true;
    }

    return false;
  };

  const formatData = data => {
    data.forEach(item => {
      if (!item.icon && icon) {
        item.icon = icon;
      }

      if (!item.sale && customStyle__12.sale) {
        item.sale = customStyle__12.sale;
      }
    });
  };

  useEffect(() => {
    if (!checkIfDynamic()) {
      formatData(channelsData__12);
      setChannels(channelsData__12);
      return;
    }

    if (cacheChannels__12.length > 0) {
      formatData(cacheChannels__12);
      setChannels(cacheChannels__12);
      return;
    }

    getChannels();
  }, []);
  return <Channels__12 channels={channels} customStyle={customStyle__12} type={showType__12.type} template={showType__12.template} nodeId={nodeId} nodeType={nodeType}></Channels__12>;
};

export default (({
  children: children
}) => {
  const pageConfig = {
    title: "蜻蜓FM庆祝党的二十大胜利召开",
    color: "#333",
    backgroundColor: "#ad0001",
    backgroundImage: "",
    margin: "",
    padding: ""
  };
  const appShareConfig = {
    shareTitle: "蜻蜓FM庆祝党的二十大胜利召开",
    shareImg: "https://sss.qtfm.cn/bp/62c52dc88921eb7b4618f35a/image/780039b5be720d89556b5266df19310c.jpg",
    shareSubTitle: "青春向党百年路，奋进喜迎二十大！",
    shareLink: "",
    isHiddenAppShare: false,
    isHiddenWxShare: false
  };
  const timeConfig = {
    startTime: "2018-10-12",
    endTime: "2025-10-12",
    useServerTime: true,
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    endRedirectUrl: "",
    redirectPromp: "当前活动已结束，自动跳入更多精彩活动"
  };
  return <WrapContainer id="bc0" nodeId="bc02b7b4-135b-43db-b260-2dcaf2b6fbc0" nodeType="component-container" children={children} pageConfig={pageConfig} appShareConfig={appShareConfig} timeConfig={timeConfig} env={process.env.SITE_ENV}><Image id="e61" nodeId="696a98c5-b226-40cc-8c0e-c3410713be61" nodeType="image" imageConfig={imageConfig} imageStyle={imageStyle} env={process.env.SITE_ENV}></Image><Image id="b8b" nodeId="2512fa63-430d-47ec-b66b-65f7508b1b8b" nodeType="image" imageConfig={imageConfig__2} imageStyle={imageStyle__2} env={process.env.SITE_ENV}></Image><TingList id="bc4" nodeId="f63cc83f-c899-4e0d-be4a-846611149bc4" nodeType="ting-list" tingConfig={tingConfig} tingStyle={tingStyle} env={process.env.SITE_ENV} AudioContext={AudioContext} /><Image id="de6" nodeId="d06229fd-d00f-4895-96d7-1d78b37d6de6" nodeType="image" imageConfig={imageConfig__4} imageStyle={imageStyle__4} env={process.env.SITE_ENV}></Image><Channels id="d82" nodeId="047fae31-f0ef-47b7-b2ff-032a840eed82" nodeType="channelList" env={process.env.SITE_ENV} config={config} /><Image id="cf2" nodeId="a0f9d70e-78bd-4178-933b-35a026debcf2" nodeType="image" imageConfig={imageConfig__6} imageStyle={imageStyle__6} env={process.env.SITE_ENV}></Image><Image id="c58" nodeId="2cdbc334-58a3-4839-8af1-c1da3543cc58" nodeType="image" imageConfig={imageConfig__7} imageStyle={imageStyle__7} env={process.env.SITE_ENV}></Image><ChannelList id="ad0" nodeId="6d1d08f5-aaa5-4570-80d5-888af7661ad0" nodeType="channelList" channelsData={channelsData} customStyle={customStyle} showType={showType} icon={icon}></ChannelList><Image id="cac" nodeId="4d05424c-7a85-4d7e-8472-5d75ea6d4cac" nodeType="image" imageConfig={imageConfig__9} imageStyle={imageStyle__9} env={process.env.SITE_ENV}></Image><ChannelList__10 id="e4b" nodeId="699cab41-6b68-48d3-aeb6-3dca185d1e4b" nodeType="channelList" channelsData={channelsData__10} customStyle={customStyle__10} showType={showType__10} icon={icon}></ChannelList__10><Image id="d32" nodeId="820d9d8f-ddf7-43cb-affb-0644e4e7fd32" nodeType="image" imageConfig={imageConfig__11} imageStyle={imageStyle__11} env={process.env.SITE_ENV}></Image><ChannelList__12 id="fd4" nodeId="fe691910-94f7-440e-a007-e77e77696fd4" nodeType="channelList" channelsData={channelsData__12} customStyle={customStyle__12} showType={showType__12} icon={icon}></ChannelList__12></WrapContainer>;
});